import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImagePipe } from './image.pipe'; 

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    ImagePipe
  ],
  exports: [
    ImagePipe
  ]
})
export class PipesModule { }



// WEBPACK FOOTER //
// C:/xampp/htdocs/Documentos/Angular/14-AdminPro/src/app/pipes/pipes.module.ts